import HomeView from './views/HomeView.vue'

export default [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/home',
    redirect: { path: '/' },
  },
]
